import {NotificationManager} from 'react-notifications';
export const notifications = NotificationManager;
export default notifications;
